import { css, SerializedStyles } from '@emotion/react';
import { useTheme } from '@mui/material';

export const useNotFoundViewStyles = (): SerializedStyles => {
  const theme = useTheme();

  return css`
  background-color: ${theme.palette.background.dark};
  height: 100%;
  padding-bottom: ${theme.spacing(3)};
  padding-top: ${theme.spacing(3)};
  
  .emptyStateImage {
    margin-top: 50px;
    display: inline-block;
    max-width: 100%;
    width: 560px;
  },
`;
};
